import { Avatar } from 'antd';
import React from 'react'

const colors = ['#4d7c0f', '#0B63AF', '#9a3412', '#26736e', '#4B32C3', '#0b63af', '#9a3412', '#154983', '#7a5900']

export default function NameAvatar({ icon, name = '', color, ...props }) {
    const initials = name.replace(/\s+/g, ' ').trim().split(' ').map((n)=>n[0]).join('') ?? ''
    
    props = {
        ...props,
        [typeof icon === 'string' ? 'src' : 'icon']: icon
    };
    if (props.src && !props.alt) {
        props.alt = name || '';
    }
    // Provide an accessible label so screen readers announce the user's name
    // rather than reading out the initials letter by letter.
    if (!props['aria-label'] && name) {
        props['aria-label'] = name;
    }
    const backgroundColor = props.src ? '' : (color || colors[Math.round((initials.toUpperCase().charCodeAt(0) - 65) / colors.length)]);
    return (
        <Avatar name={name} {...props} style={{ backgroundColor, ...props.style }} >{!icon && initials}</Avatar>
    )
}
